import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  WbBaseItem,
  WbDataCounter,
  WbDataCounterPercent,
  WbDataDuration,
  WbDataLiveCalls,
  WbDataQueueAgents,
} from '../models/wb-base-item';
import { WbDashboardItem } from '../models/wb-dashboard-item';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { NgStyle, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { WbQueueAgentsWidgetComponent } from './wb-queue-agents-widget.component';
import { WbLiveCallsWidgetComponent } from './wb-live-calls-widget.component';
import { DurationPipe } from '../../../core/pipes/duration.pipe';
import { LocalPbxService } from '../../local-pbx.service';

@Component({
    selector: 'app-pbx-wb-item',
    templateUrl: './wb-base-item.component.html',
    styleUrls: ['./wb-base-item.component.scss'],
    standalone: true,
    imports: [
        NgStyle,
        MatIcon,
        NgIf,
        MatIconButton,
        MatTooltip,
        WbQueueAgentsWidgetComponent,
        WbLiveCallsWidgetComponent,
        DurationPipe,
    ],
})
export class WbBaseItemComponent implements OnChanges {
  @Input() gridItem: WbDashboardItem;
  @Input() itemData: WbDataCounter | WbDataCounterPercent | WbDataDuration | WbDataQueueAgents | WbDataLiveCalls;
  @Input() isEditing: boolean;

  @Output() removeWidgetEvent = new EventEmitter<WbBaseItem>();

  item: WbBaseItem = {
    id: '',
    type: '',
    title: '',
    icon: '',
  };
  counterData: WbDataCounter;
  counterPercentData: WbDataCounterPercent;
  durationData: WbDataDuration;
  queueAgentsData: WbDataQueueAgents;
  liveCallsData: WbDataLiveCalls;

  constructor(private pbxService: LocalPbxService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.counterData = { value: 0 };
    this.counterPercentData = { count: 0, percent: 0 };

    this.item = this.gridItem.item ?? {
      id: '',
      type: '',
      title: '',
      icon: '',
    };

    if (this.item.type === 'counter' && this.itemData) {
      this.counterData = this.itemData as WbDataCounter;
    }
    if (this.item.type === 'counterPercent' && this.itemData) {
      this.counterPercentData = this.itemData as WbDataCounterPercent;
    }
    if (this.item.type === 'duration' && this.itemData) {
      this.durationData = this.itemData as WbDataDuration;
    }
    if (this.item.type === 'queueAgents' && this.itemData) {
      this.queueAgentsData = this.itemData as WbDataQueueAgents;
      // Sync filterActive from LocalPbxService
      if (this.queueAgentsData.groupId) {
        this.queueAgentsData.filterActive = this.pbxService.getQueueAgentsFilterActive(this.queueAgentsData.groupId);
      }
    }
    if (this.item.type === 'liveCalls' && this.itemData) {
      this.liveCallsData = this.itemData as WbDataLiveCalls;
    }
  }

  onToggleAgentsFilterChange($event: any, item: WbDataQueueAgents) {
    if (item.groupId) {
      const newValue = !this.pbxService.getQueueAgentsFilterActive(item.groupId);
      this.pbxService.setQueueAgentsFilterActive(item.groupId, newValue);
      item.filterActive = newValue;
    } else {
      item.filterActive = !item.filterActive;
    }
  }
}
